import CardComponent from 'core/card'
import React, { useState } from 'react'
import { OnGetDeviceCallback } from '../RtfComponent'
import SearchComponent from './components/Search'

type DeviceProps = {
  onGetDevice: OnGetDeviceCallback
  deviceIdQuery: string
}

export default function DeviceComponent({ onGetDevice, deviceIdQuery = '' }: DeviceProps) {
  const [udid, setUdid] = useState(deviceIdQuery)

  return (
    <CardComponent>
      <SearchComponent udid={udid} setUdid={setUdid} onGetDevice={onGetDevice} />
    </CardComponent>
  )
}
